import { useState, useEffect } from 'react';

export interface Size {
	width: number | undefined;
	height: number | undefined;
}

export function useWindowSize(): Size {
	const [windowSize, setWindowSize] = useState<Size>({
		width: undefined,
		height: undefined,
	});

	useEffect(() => {
		function handleResize() {
			setWindowSize({
				width: window.innerWidth,
				height: window.innerHeight,
			});
		}

		window.addEventListener('resize', handleResize);

		handleResize(); //init

		return () => window.removeEventListener('resize', handleResize);
	}, []); // empty array ensures that effect is only run on mount
	return windowSize;
}
